import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette, TextField } from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';
import { ZodTypeAny } from 'zod';

interface Props {
  option: any;
  handleValueChanged: (optionId: string, valueId: string) => void;
  setValidationError: (index: string | number, value: boolean) => void;
  index: string | number;
  validationSchema: ZodTypeAny | undefined;
  currentValue: number;
  forceValidate?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    panel: {
      backgroundColor: MaterialPalette.background.paper2,
      '& h6': {
        fontSize: '20px',
        color: MaterialPalette.tertiary.main,
      },
    },
    checkboxLabel: {
      width: '100%',
    },
    optionsContainer: {
      paddingLeft: '30px',
      '& > div > span': {
        color: MaterialPalette.primary.main,
      },
    },
    nested: {
      paddingLeft: '30px',
    },
  }),
);

const GroundControlNumberOption = ({
  option,
  handleValueChanged,
  setValidationError,
  index,
  validationSchema,
  currentValue,
  forceValidate = false,
}: Props) => {
  const classes = useStyles();

  const [errorText, setErrorText] = useState('');

  const validate = (optionValue: any) => {
    if (!validationSchema) {
      setValidationError(index, false);
      setErrorText('');
      return;
    }

    const result = validationSchema.safeParse(optionValue);
    if (!result.success) {
      setValidationError(index, true);
      const errors = result?.error?.format();
      setErrorText(errors?._errors[0] || '');
    } else {
      setValidationError(index, false);
      setErrorText('');
    }
  };

  const onChanged = (optionValue: any) => {
    validate(optionValue);
    handleValueChanged(option.id, optionValue);
  };

  useEffect(() => {
    if (forceValidate) {
      validate(currentValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceValidate, currentValue]);

  return (
    <>
      <Grid item container xs={12} key={option.id} className={classes.nested}>
        <TextField
          label={`${option.description} ${option.isRequired ? '' : '(Optional)'}`}
          onChange={e => onChanged(e.target.value)}
          value={currentValue}
          fullWidth
          variant="outlined"
          error={errorText !== ''}
          errorText={errorText}
          unitText={option.unitOfMeasure || undefined}
        />
      </Grid>
    </>
  );
};

export default GroundControlNumberOption;
